import { DriveGlobalAccessType } from '@/security/types/AccessTarget';

export const DRIVE_TARGET_NAME: Record<DriveGlobalAccessType, string> = {
  driveProject: 'Project',
  driveFolder: 'Folder',
  collection: 'Collection',
};
